module.exports = __webpack_public_path__ + "img/menu1_banner01.bb32d4ee.png";